<template>
    <SectionBasicLayout
      title='settings.layout.title'
      content_class="layout-options"
      close_route="settings"
    >

        <template #content>
            <form>
                <LayoutColorsList
                  :layout_controller="layout_controller"
                />

                <LayoutViewMode
                  :layout_controller="layout_controller"
                />

                <LayoutOrientation
                  :layout_controller="layout_controller"
                />

                <LayoutFontSize
                  :layout_controller="layout_controller"
                />
            </form>
        </template>

    </SectionBasicLayout>
</template>

<script setup>
  import SectionBasicLayout         from '@/vue/Layouts/Sections/SectionBasicLayout.vue';
  import LayoutSettingsController   from '@/js/Webmail/LayoutSettingsController';
  import LayoutColorsList           from './Partials/LayoutColorsList.vue';
  import LayoutViewMode             from './Partials/LayoutViewMode.vue';
  import LayoutOrientation          from './Partials/LayoutOrientation.vue';
  import LayoutFontSize             from './Partials/LayoutFontSize.vue';

  const layout_controller = LayoutSettingsController;
</script>